import React from 'react';
import { PrintDataFields as LocalPrintDataFields } from './hooks/use-print-data';
import { PrintPage } from './components/PrintPage';

export interface PrintArbreProps {
  printData: LocalPrintDataFields;
  inventaireId: number;
  isMobile: boolean;

}

/**
 * Pure UI component for printing arbre inventaire data.
 * Does not fetch data - expects printData to be provided via props.
 * The parent component is responsible for fetching and passing the data.
 */
export default function PrintArbre({ printData, inventaireId, isMobile = false }: PrintArbreProps) {
  return (
    <div className={`bg-gray-100 min-h-screen`}>
      <PrintPage data={printData as LocalPrintDataFields} inventaireId={inventaireId} />
    </div>
  );
}
